import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DesktopService } from '../../services/desktop.service';
import { NavigationService } from '../../services/navigation.service';
import { SettingsMenuComponent } from '../../components/settings-menu/settings-menu.component';

@Component({
   selector: 'asc-settings',
   templateUrl: './settings.component.html',
   styleUrls: ['./settings.component.scss'],
   imports: [
      RouterModule,
      SettingsMenuComponent
   ]
})
export class SettingsComponent {
   private activatedRoute = inject(ActivatedRoute);
   private desktopService = inject(DesktopService);
   private navigationService = inject(NavigationService);

   public title = 'Einstellungen';

   // -------------------------------------------------------------- Properties

   private get hasChildRoutes(): boolean {
      return this.activatedRoute.children.length > 0;
   }

   public get isSettingsMenuVisible(): boolean {
      return this.desktopService.canShowSettingsPanel || !this.hasChildRoutes;
   }

   public get isSettingsPanelVisible(): boolean {
      return this.desktopService.canShowSettingsPanel || this.hasChildRoutes;
   }

   // -------------------------------------------------------------- Operations

   public navigateBack() {
      this.navigationService.navigateToSettings();
   }
}
